export default function getQuotes() {
  return [
    {
      content: `People Join People. How do you center relationship building in the joining process?`,
      author: '',
      subtitle: '',
    },
    {
      content: `You Can't Recruit Who You Don't Know. While you refresh, think about who you could meet today and the impact it may have on their life.`,
      author: '',
      subtitle: '',
    },
  ];
}
